import sideMenuList from '../../helpers/sideListItems';
import getLangData from '../../utils/getLangData';
// import { store } from '../../services/configureStore';

// const userType = store.getState().auth
// console.log(userType)
// const menuConfig = (type) => ({

const langData = getLangData().menu.side;
export default {
  header: {
    self: {},
    items: [
      {
        title: langData.dashboard,
        root: true,
        alignment: 'left',
        page: 'dashboard',
        translate: 'MENU.DASHBOARD'
      }
    ]
  },
  aside: {
    self: {},

    // items: sideMenuList(type),
    items: [
      {
        title: langData.dashboard,
        root: true,
        // icon: "icon-my-dashboard-warshatna",
        icon: 'fas fa-home',
        page: 'dashboard',
        translate: 'MENU.DASHBOARD',
        bullet: 'dot'
      },
      {
        title: langData.users,
        root: true,
        // icon: "icon-users-warshatna",
        icon: 'fas fa-users',
        user: '0',
        page: 'users'
        // submenu: [
        // 	{ title: "All Users", page: "users", icon: "flaticon-avatar" },
        // 	{ title: "Artisans", page: "artisans", icon: " flaticon-customer" },
        // 	{ title: "Suppliers", page: "suppliers", icon: "flaticon-user" },
        // 	{ title: "Customers", page: "customers", icon: "flaticon-avatar" },
        // ],
      },
      {
        title: langData.training_center,
        root: true,
        icon: 'far fa-building',
        user: '0',
        page: 'training-center'
      },
      {
        title: langData.products,
        root: false,
        bullet: 'dot',
        // icon: "icon-my-products-warshatna",
        icon: 'fas fa-boxes',
        user: '0',
        submenu: [
          { title: langData.manage_artisan_products, page: 'artisan-products' },
          {
            title: langData.manage_supplier_products,
            page: 'supplier-products'
          }
        ]
      },
      {
        title: langData.my_artisan_products,
        root: false,
        bullet: 'dot',
        icon: 'fas fa-boxes',
        user: '0',
        page: 'my-artisan-products'
      },
      // {
      //   title: 'Artisan Jobs',
      //   root: false,
      //   bullet: 'dot',
      //   icon: 'fas fa-briefcase',
      //   user: '0',
      //   page: 'my-artisan-jobs',
      // },
      {
        title: langData.artisan_fav_products,
        root: false,
        bullet: 'dot',
        icon: 'fas fa-boxes',
        user: '0',
        page: 'artisan-fav-products'
      },
      {
        title: langData.supplier_fav_products,
        root: false,
        bullet: 'dot',
        icon: 'fas fa-boxes',
        user: '0',
        page: 'supplier-fav-products'
      },
      {
        title: langData.my_supplier_products,
        root: false,
        bullet: 'dot',
        icon: 'fas fa-boxes',
        user: '0',
        page: 'my-supplier-products'
      },
      {
        title: langData.my_artisan_jobs,
        root: false,
        bullet: 'dot',
        icon: 'fas fa-briefcase',
        user: '0',
        page: 'jobs/artisan'
      },
      {
        title: 'الوظائف',
        root: false,
        bullet: 'dot',
        icon: 'fas fa-briefcase',
        user: '0',
        page: 'jobs/my-apply'
      },

      {
        title: 'وظائف تناسب مهاراتي',
        root: false,
        bullet: 'dot',
        icon: 'fas fa-briefcase',
        user: '0',
        page: 'jobs/recommendation'
      },
      {
        title: langData.my_supplier_jobs,
        root: false,
        bullet: 'dot',
        icon: 'fas fa-briefcase',
        user: '0',
        page: 'jobs/supplier'
      },
      {
        title: langData.my_public_inquiries_artisan,
        root: false,
        bullet: 'dot',
        icon: 'flaticon-shapes',
        user: '0',
        page: 'my-public-inquiries-artisan'
      },
      {
        title: langData.my_private_inquiries_artisan,
        root: true,
        // bullet: 'dot',
        icon: 'flaticon-shapes',
        user: '0',
        page: 'my-private-inquiries-artisan'
      },
      {
        title: langData.customer_public_inquiries,
        root: false,
        bullet: 'dot',
        name: 'Customer Public Inquiries',
        icon: 'flaticon-shapes',
        user: '0',
        submenu: [
          {
            title: langData.customer_public_inquiry_artisan,
            page: 'customer-public-inquiry-artisan'
          },
          {
            title: langData.customer_public_inquiry_supplier,
            page: 'customer-public-inquiry-supplier'
          }
        ]
      },
      {
        title: langData.customer_private_inquiries,
        root: true,
        name: 'Customer Private Inquiries',
        // bullet: 'dot',
        icon: 'flaticon-shapes',
        user: '0',
        submenu: [
          {
            title: langData.customer_private_inquiry_artisan,
            page: 'customer-private-inquiry-artisan'
          },
          {
            title: langData.customer_private_inquiry_supplier,
            page: 'customer-private-inquiry-supplier'
          }
        ]
      },
      {
        title: langData.customer_private_inquiry_artisan,
        root: false,
        icon: 'flaticon-shapes',
        user: '0',
        page: 'customer-private-inquiry-artisan'
      },
      {
        title: langData.customer_public_inquiry_artisan,
        root: false,
        icon: 'flaticon-shapes',
        user: '0',
        page: 'customer-public-inquiry-artisan'
      },

      {
        title: langData.categories,
        icon: 'flaticon2-layers-1',
        root: false,
        bullet: 'dot',
        user: '0',
        submenu: [
          {
            title: langData.artisan_categories,
            page: 'artisan-categories'
          },
          {
            title: langData.supplier_categories,
            page: 'supplier-categories'
          }
        ]
      },

      {
        title: langData.job_categories,
        icon: 'flaticon2-layers-1',
        root: false,
        bullet: 'dot',
        user: '0',
        submenu: [
          {
            title: langData.artisan_categories,
            page: 'job/artisan-categories'
          },
          {
            title: langData.supplier_job_categories,
            page: 'job/supplier-categories'
          }
        ]
      },
      {
        title: langData.tags,
        root: false,
        bullet: 'dot',
        icon: 'flaticon-shapes',
        user: '0',
        submenu: [
          { title: langData.artisan_tags, page: 'artisan-tags' },
          { title: langData.supplier_tags, page: 'supplier-tags' }
        ]
      },
      {
        title: langData.moderation,
        root: false,
        bullet: 'dot',
        icon: 'flaticon2-expand',
        user: '0',
        submenu: [
          {
            title: langData['artisans-moderation'],
            page: 'artisans-moderation'
          },
          {
            title: langData['suppliers-moderation'],
            page: 'suppliers-moderation'
          },
          {
            title: langData['customers-moderation'],
            page: 'customers-moderation'
          },
          {
            title: langData['applicants-moderation'],
            page: 'applicants-moderation'
          }
          // { title: 'Training Center Moderation', page: 'training-center' },
        ]
      },
      {
        title: langData.settings,
        page: 'user-settings',
        root: true,
        icon: 'flaticon-cogwheel-2',
        user: '0'
      },
      {
        title: langData.create_profiles,
        page: 'create-profiles',
        root: true,
        icon: 'flaticon-cogwheel-2',
        user: '0'
      },
      // {
      //   title: 'Private Inquiries',
      //   root: true,
      //   // bullet: 'dot',
      //   icon: 'flaticon-shapes',
      //   user: '0',
      //   page: 'my-private-inquiries-artisan',
      // },
      {
        title: langData.my_public_inquiries_supplier,
        root: false,
        bullet: 'dot',
        icon: 'flaticon-shapes',
        user: '0',
        page: 'my-public-inquiries-supplier'
      },
      {
        title: langData.my_private_inquiries_supplier,
        root: true,
        // bullet: 'dot',
        icon: 'flaticon-shapes',
        user: '0',
        page: 'my-private-inquiries-supplier'
      },
      {
        title: 'Reports',
        root: false,
        icon: 'icon-reports-warshatna',
        bullet: 'dot',
        user: '0',
        submenu: [
          { title: 'Users', page: 'reports/users' },
          { title: 'Artisans', page: 'reports/artisans' },
          { title: 'Suppliers', page: 'reports/suppliers' },
          { title: 'Artisans Tags', page: 'reports/artisans-tags' },
          { title: 'Suppliers Tags', page: 'reports/suppliers-tags' },
          {
            title: 'Artisans Categories',
            page: 'reports/artisans-categories'
          },
          {
            title: 'Suppliers Categories',
            page: 'reports/suppliers-categories'
          }
        ]
      }
    ]
  }
};

// export default menuConfig;
// customer menu
